// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { getCategoryListFailed, getCategoryListRequested, getCategoryListSucceeded } from './select-category.actions';
import { DictionariesService } from '@par/app/core/data-services/dictionaries.service';

@Injectable()
export class SelectCategoryEffects {

  listRequested$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getCategoryListRequested),
      mergeMap(() => this.service.getCategoryList()
        .pipe(
          map((response) => getCategoryListSucceeded({response})),
          catchError(() => of(getCategoryListFailed())),
        )),
    ),
  );

  constructor(
    private actions$: Actions,
    private service: DictionariesService,
  ) {
  }
}
